module.exports = __webpack_public_path__ + "img/3.d08b4db6.png";